export default [
    {
        path: "/",
        name: "home",
        component: () => import("./index"),
        meta: {
            title: "智慧物联"
        }
    }
]